export default "__VITE_ASSET__ClEfUkKu__"